var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#72A606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5063 6.00022C15.3817 6.00409 15.2635 6.05835 15.1766 6.1515L11.5099 9.97262L7.84318 13.7937L4.82552 10.649C4.78133 10.601 4.72841 10.5627 4.66984 10.5364C4.61128 10.51 4.54825 10.4961 4.48446 10.4954C4.42066 10.4947 4.35737 10.5073 4.29831 10.5324C4.23924 10.5576 4.18558 10.5947 4.14046 10.6417C4.09535 10.6887 4.05969 10.7447 4.03558 10.8062C4.01146 10.8678 3.99938 10.9337 4.00002 11.0002C4.00067 11.0667 4.01405 11.1324 4.03936 11.1934C4.06467 11.2544 4.10141 11.3096 4.14743 11.3556L7.50414 14.8537C7.59407 14.9474 7.71602 15 7.84318 15C7.97034 15 8.09229 14.9474 8.18222 14.8537L15.8547 6.85814C15.924 6.78795 15.9713 6.69758 15.9905 6.59887C16.0096 6.50017 15.9997 6.39773 15.9621 6.30499C15.9244 6.21225 15.8607 6.13353 15.7794 6.07914C15.6981 6.02476 15.6029 5.99725 15.5063 6.00022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.45762a4786b32ac51656c7ffb7b175da.svg";
export { ForwardRef as ReactComponent };